export namespace InstallationFeaturesHelpers {
  export function constructInstallationFeatureUri(
    baseUri: string,
    featureName: string,
    gatewaySerial: string,
    installationId: number,
    deviceId?: string
  ): string {
    let uri = `${baseUri}/${installationId}/gateways/${gatewaySerial}`;

    if (deviceId) {
      uri += `/devices/${deviceId}/features/${featureName}`;
    } else {
      uri += `/features/${featureName}`;
    }

    return uri;
  }
}
